function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 0c11.021 0 20 8.979 20 20s-8.979 20-20 20S0 31.021 0 20 8.979 0 20 0zm0 1.569C9.845 1.569 1.569 9.845 1.569 20c0 10.155 8.276 18.431 18.431 18.431 10.155 0 18.431-8.276 18.431-18.431C38.431 9.845 30.155 1.569 20 1.569z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.119 18.87l-.063-8.557 1.532.001.027 5.865 5.577-5.544 1.188 1.188-5.573 5.543 5.894.035v1.531z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.897 18v.091h.067l6.305-6.27-.079-.079zM19.644 20.345l-8.557-.062.001 1.532 5.865.026-5.545 5.577 1.189 1.189 5.543-5.574.034 5.894h1.532z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.774 21.123h.091v.067l-6.27 6.306-.079-.08z"
}));

function SvgMoreViewsMenuClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMoreViewsMenuClose;